import { formatCents } from "../shared/money";
import { saveFile } from "../../../../native/files";

// Label keys (English sentences, translated through the "accounting" namespace) and colours
// for the enums the ledger uses.
export const ORIGINS = [
  "invoice",
  "credit_note",
  "receipt",
  "bank",
  "cash",
  "payment",
  "payroll",
  "depreciation",
  "dunning",
  "manual",
  "opening",
  "closing",
  "reversal"
];

export const ORIGIN_LABELS = {
  invoice: "Invoice",
  credit_note: "Credit note",
  receipt: "Receipt",
  bank: "Bank",
  cash: "Cash",
  payment: "Payment",
  payroll: "Payroll",
  depreciation: "Depreciation",
  dunning: "Dunning",
  manual: "Manual",
  opening: "Opening balance",
  closing: "Closing",
  reversal: "Reversal (Storno)"
};

export const ORIGIN_COLORS = {
  invoice: "blue",
  credit_note: "geekblue",
  receipt: "cyan",
  bank: "green",
  cash: "lime",
  payment: "green",
  payroll: "purple",
  depreciation: "gold",
  dunning: "volcano",
  manual: "default",
  opening: "magenta",
  closing: "magenta",
  reversal: "red"
};

export const ACCOUNT_TYPES = [
  "asset",
  "liability",
  "equity",
  "revenue",
  "expense",
  "debitor",
  "kreditor",
  "neutral"
];

export const TYPE_LABELS = {
  asset: "Asset",
  liability: "Liability",
  equity: "Equity",
  revenue: "Revenue",
  expense: "Expense",
  debitor: "Debitor (customer)",
  kreditor: "Kreditor (supplier)",
  neutral: "Neutral"
};

export const TYPE_COLORS = {
  asset: "blue",
  liability: "orange",
  equity: "purple",
  revenue: "green",
  expense: "red",
  debitor: "cyan",
  kreditor: "gold",
  neutral: "default"
};

export const TAX_KINDS = ["none", "output", "input", "rc_out", "rc_in"];

export const TAX_KIND_LABELS = {
  none: "No tax",
  output: "Output VAT (Umsatzsteuer)",
  input: "Input VAT (Vorsteuer)",
  rc_out: "Reverse charge, tax owed (§ 13b)",
  rc_in: "Reverse charge, input tax (§ 13b)"
};

export const PERIOD_STATUS_COLORS = { open: "processing", closed: "default", filed: "success" };

/** "1.234,56 € S" / "1.234,56 € H": positive = Soll-Saldo, negative = Haben-Saldo. */
export const formatBalance = cents => {
  const n = Number(cents || 0);
  if (n === 0) return formatCents(0);
  return `${formatCents(Math.abs(n))} ${n > 0 ? "S" : "H"}`;
};

/** Short "Konto → Gegenkonto" summary of an entry's lines. */
export const linesSummary = lines => {
  const debit = [...new Set((lines || []).filter(l => l.debit > 0).map(l => l.account))];
  const credit = [...new Set((lines || []).filter(l => l.credit > 0).map(l => l.account))];
  return `${debit.join(", ")} → ${credit.join(", ")}`;
};

export const sumDebit = lines => (lines || []).reduce((s, l) => s + (Number(l.debit) || 0), 0);
export const sumCredit = lines => (lines || []).reduce((s, l) => s + (Number(l.credit) || 0), 0);

/** Client-side CSV download: German Excel conventions (semicolon, BOM, comma decimals). */
export const downloadCsv = (filename, header, rows) => {
  const escape = v => {
    const s = v === null || v === undefined ? "" : String(v);
    return /[";\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const lines = [header, ...rows].map(r => r.map(escape).join(";"));
  const blob = new Blob(["﻿" + lines.join("\r\n")], { type: "text/csv;charset=utf-8" });
  return saveFile(blob, filename);
};

export const csvMoney = cents => (Number(cents || 0) / 100).toFixed(2).replace(".", ",");
